<template>
  <div class="PersonIOListWeb">
    <v-data-table
      dense
      :disable-sort="false"
      :headers="headers"
      hide-default-footer
      disable-pagination
      :items="list"
      @click:row="handleClick"
      item-key="MessageId"
      :item-class="getItemClass"
    />
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("date"),
          value: "ClockDate",
        },
        {
          text: this.$t("time"),
          value: "ClockTime",
        },
        {
          text: this.$t("io"),
          value: "Io",
        },
        {
          text: this.$t("RequestTime"),
          value: "RequestTime",
        },
        {
          text: this.$t("RequestDate"),
          value: "RequestDate",
        },
        {
          text: this.$t("status"),
          value: "StatusType",
        },
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClickIO", value);
    },
    getItemClass(item) {
      //console.log(item);
      if (item.EvacuationSystem == "1") {
        return "bg-green";
      }
    },
  },
};
</script>

<style>
</style>